import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Avatar from '@components/@core/Avatar';
import Icon from '@components/@core/Icon';
import EditDropdown from '@components/EditDropdown';

const CategoryHeader = () => (
    <div className="d-flex mx-0 py-4 desktop-screen">
        <div className="d-flex-3 dsl-m12">Category</div>
        <div className="d-flex-1 dsl-m12 text-center">posts</div>
        <div className="d-flex-2 d-h-center">
            <Icon name="far fa-comment" size={12} />
        </div>
        <div className="d-flex-2 d-h-center">
            <Icon name="far fa-eye" size={12} />
        </div>
        <div className="d-flex-3 dsl-m12">Latest post</div>
        <div className="d-flex-1" />
    </div>
);

const CategoryItem = ({ item, onClick, enable, onSelect }) => {
    const { name, latest, stats } = item;
    return (
        <div className="d-flex cursor-pointer mx-0 py-3">
            <div className="d-flex ssm-column d-flex-12" onClick={() => onClick && onClick(item)}>
                <div className="d-flex-3 d-h-start dsl-b16">
                    <span className="department-logo">
                        <Icon name={`fas fa-folders`} size={16} />
                    </span>
                    <span className="dsl-b16 ms-2 w-60">{name}</span>
                    {enable && <EditDropdown className="mobile-screen" options={['Edit', 'Delete']} onChange={onSelect(item)} />}
                </div>
                <div className="d-flex-1 d-flex ai-center jc-center ssm-left dsl-b16 py-2 py-sm-0">
                    <label className="dsl-b14 mobile-screen w-40">posts</label>
                    {stats?.posts || 0}
                </div>
                <div className="d-flex-2 d-flex ai-center jc-center ssm-left dsl-b16 py-2 py-sm-0">
                    <Icon name="far fa-comment dsl-b14 mobile-screen w-40" size={12} />
                    {stats?.comments || 0}
                </div>
                <div className="d-flex-2 d-flex ai-center jc-center ssm-left dsl-b16 py-2 py-sm-0">
                    <Icon name="far fa-eye dsl-b14 mobile-screen w-40" size={12} />
                    {stats?.views || 0}
                </div>
                <div className="d-flex d-flex-3 ai-center ssm-jc-start mt-0 ssm-y-2">
                    <label className="dsl-b14 mobile-screen w-40 mb-0">Latest Posts</label>
                    <p className="dsl-b16 mb-0 truncate text-500 mw-150">{latest?.name}</p>
                </div>
            </div>
            <div className="d-flex-1 d-h-end desktop-screen">{enable && <EditDropdown options={['Edit', 'Delete']} onChange={onSelect(item)} />}</div>
        </div>
    );
};

const CategoryDetailedItem = ({ post }) => {
    const { name, data, created_at } = post;
    return (
        <>
            <div className="d-h-between">
                <div className="d-h-start">
                    <Avatar type="logo" url={post.author_avatar} isSponsored={true} />
                    <div className="ml-2">
                        <p className="dsl-m14 mb-2">
                            {post.author?.first_name} {post.author?.last_name}
                        </p>
                        <p className="dsl-m14 mb-0">{post.profile?.company}</p>
                    </div>
                </div>
                <p className="dsl-m14 mb-0">{moment(created_at).format('MMM DD, YY')}</p>
            </div>
            <p className="dsl-b18 bold my-3 truncate-two">{name}</p>
            <div className="post-body" dangerouslySetInnerHTML={{ __html: data?.body }} />
        </>
    );
};

export const CategoryFeed = ({ category, posts }) => {
    if (!category?.name) return null;
    const { name } = category;
    return (
        <div className="bg-white">
            <p className="dsl-b20 bold pt-3 ps-3 mb-0 mt-2">{name}</p>
            {posts.length > 0 ? (
                posts?.map((item, index) => (
                    <div className="blog-category-section mt-3" key={`item-${index}`}>
                        <CategoryDetailedItem post={item} />
                    </div>
                ))
            ) : (
                <p className="dsl-b16 p-3">{`There are no ${name.toLowerCase()} posts.`}</p>
            )}
        </div>
    );
};

const Categories = ({ categories, onDetail, onSelect }) => {
    const handleOpenDetail = (item) => {
        onDetail && onDetail(item);
    };
    return (
        <div className="card blog-category-section mt-2 mb-3">
            {categories.length > 0 ? (
                <>
                    <p className="dsl-b20 bold my-2">Public</p>
                    <CategoryHeader />
                    {categories.map((category, index) => (
                        <CategoryItem key={`category-${index}`} item={category} onClick={handleOpenDetail} enable={category.name !== 'Uncategorized'} onSelect={onSelect(index)} />
                    ))}
                </>
            ) : (
                <p className="dsl-b16 p-3">{`There are no categories.`}</p>
            )}
        </div>
    );
};

Categories.propTypes = {
    categories: PropTypes.array,
    onSelect: PropTypes.func,
};

Categories.defaultProps = {
    categories: [],
    onSelect: () => {},
};

export default Categories;
